<template>
    <BreadCrumb PageTitle="Detail emplacement" />
    <ViewEmplacement />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ViewEmplacement from "../../components/Emplacement/ViewEmplacement.vue";
    export default defineComponent({
      name: "ViewEmplacementPage",
      components: {
        BreadCrumb,
        ViewEmplacement,
      },
    });
  </script>